export var mutations = {
    setStatus: function (s, payload) { return s.status = payload; },
    setLoading: function (s, payload) { return s.loading = payload; },
};
